import { render, staticRenderFns } from "./AccountOptions.vue?vue&type=template&id=d8449b9a&scoped=true&"
var script = {}
import style0 from "./AccountOptions.vue?vue&type=style&index=0&id=d8449b9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8449b9a",
  null
  
)

export default component.exports